import {
  SpecialModalController
} from './special-modal.component';

export class SpecialModalService {

  constructor($timeout, $modal, $http, ErrorHandlerService, PermissionService) {
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.$http = $http;
    this.ErrorHandlerService = ErrorHandlerService;
    this.PermissionService = PermissionService;
  }

  open(permission, confirmation, onSuccess) {
    return this.$modal.open({
      template: require('./special-modal.component.html'),
      controller: SpecialModalController,
      resolve: {
        'success': () => onSuccess,
        'permission': () => permission,
        'confirmation': () => confirmation,
      },
    });
  }

  deleteEvent(eventId, onSuccess) {
    const self = this;
    this.open('can_delete_event', gettext('Удалить это событие и все связанные с ним файлы?'), function ok(token) {
      self.$http.get('/admin/delete-event/?token=' + token + '&id=' + eventId).then(
        function success() {
          onSuccess();
        },
        function failed(error) {
          self.ErrorHandlerService.handle(error);
        }
      );
    });
  }

  createDeletePolicy(onSuccess) {
    const self = this;
    this.open('can_mass_delete', gettext('Создать политику удаления событий?'), function ok(token) {
      console.log('создаем политику');
      onSuccess();
    });
  }

  askSpecial(permission, confirmation, onSuccess) {
    const self = this;
    // Called from plain JS, so load permissions first
    this.PermissionService.load(function loaded() {
      self.open(permission, confirmation, function ok(token) {
        const spinner = document.createElement('sc-hspinner');
        const div = document.createElement('div');
        div.setAttribute('class', 'image-hspinner');
        const h5 = document.createElement('h5');
        h5.textContent = gettext('Пожалуйста подождите') + '...';
        h5.style.width = '200px';
        h5.style.backgroundColor = 'white';
        h5.style.padding = '10px';
        h5.style.marginLeft = '-60px';
        div.appendChild(h5);
        spinner.appendChild(div);
        document.body.appendChild(spinner);
        onSuccess(token);
      });
    });
  }

  openTerminal() {
    this.open('can_access_terminal', false, function ok(token) {
      window.open('/console/console/?token=' + token);
    });
  }
}



// WEBPACK FOOTER //
// ./src/core/special-modal/special-modal.service.js